import { Directive, EventEmitter, ElementRef, HostListener, Output, Input } from '@angular/core';

@Directive({
	selector: '[shClickOutside]',
	standalone: true
})
export class ClickOutsideDirective {
	@Output() public shClickOutside = new EventEmitter();
	@Input() public isFirstClick?: boolean;

	private el: Element;
	// eslint-disable-next-line @typescript-eslint/naming-convention
	constructor(public _elementRef: ElementRef) {
		this.el = _elementRef.nativeElement;
	}

	@HostListener('document:click', ['$event.target'])
	public onClick(targetElement: Element): void {
		const clickedInside: boolean = this.el.contains(targetElement);
		if (!clickedInside && !this.isFirstClick) {
			this.shClickOutside.emit(true);
		} else {
			this.shClickOutside.emit(false);
		}
	}
}
